import type { GeneratedColors, Palette } from '@lokalise/louis';
import { designTokens, generateThemeColors as generateColors } from '@lokalise/louis';

export const { palette } = designTokens;

const legacyColors = {
    sidebarNav: {
        inactive: {
            foreground: { light: '#8a8a8a', dark: '#8a8a8a' },
        },
        active: {
            foreground: { light: '#5489dc', dark: '#5489dc' },
            background: { light: '#ffffff73', dark: '#343434' },
        },
    },
};

type Color = string;

type CustomColors = {
    tasks: {
        tag: {
            translation: Color;
            review: Color;
            due: Color;
        };
    };
    sidebarNav: {
        inactive: {
            foreground: Color;
        };
        active: {
            foreground: Color;
            background: Color;
        };
    };
};

export const generateThemeColors = (
    colorPalette: Palette,
    theme: 'light' | 'dark',
): GeneratedColors & CustomColors => ({
    ...generateColors(palette, theme),
    // This probably shouldn't be here but currently there's no way to extend theme from app.
    tasks: {
        tag: {
            translation: '#76BEDB',
            review: '#74B766',
            due: '#DEA829',
        },
    },
    sidebarNav: {
        inactive: {
            foreground: legacyColors.sidebarNav.inactive.foreground[theme],
        },
        active: {
            foreground: legacyColors.sidebarNav.active.foreground[theme],
            background: legacyColors.sidebarNav.active.background[theme],
        },
    },
});
